import { render, staticRenderFns } from "./LoginWeb.vue?vue&type=template&id=b20b870e&scoped=true&"
import script from "./LoginWeb.vue?vue&type=script&lang=js&"
export * from "./LoginWeb.vue?vue&type=script&lang=js&"
import style0 from "./LoginWeb.vue?vue&type=style&index=0&id=b20b870e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20b870e",
  null
  
)

export default component.exports